import React, { useState } from "react";
import {
  Box,
  FormLabel,
  Dialog,
  DialogTitle,
  DialogContent,
  Typography,
  IconButton,
  TextareaAutosize,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import "../../css/OutPutDirectory.css"; // Import the CSS file
import { useDispatch, useSelector } from "react-redux";
import {
  saveFormDetails
} from "../../redux/slices/CreateAgentSlice";

const Prompts = ({error,setErrors}) => {
  const [open, setOpen] = useState(false);
  const [popupMessage, setPopupMessage] = useState({});
  const dispatch = useDispatch();
  const {
    formDetails
  } = useSelector((state) => state.CreateAgentSlice);

  const handleClose = () => {
    setOpen(false);
  };

  const handleTextInput = (value,key)=>{
    dispatch(
      saveFormDetails({ key, value: value?.target?.value })
    );

  }

  return (
    <div>
      <Box className="prompt-container">
        <FormLabel style={{ fontWeight: "bold" }}>System Instruction</FormLabel>
        <textarea
  className="fixed-textarea"
  value={formDetails?.system_instruction}
  onChange={(e) => handleTextInput(e, 'system_instruction')}
/>
{error.system_instruction && (
  <div style={{ color: "red", fontSize: "12px" }}>{error.system_instruction}</div>
)}

<FormLabel style={{ fontWeight: "bold" }}>Output Instruction</FormLabel>
<textarea
  className="fixed-textarea"
  value={formDetails?.output_instruction}
  onChange={(e) => handleTextInput(e, 'output_instruction')}
/>
{error.output_instruction && (
  <div style={{ color: "red", fontSize: "12px" }}>{error.output_instruction}</div>
)}

      </Box>

      {/* Popup Dialog */}
      <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth>
        <DialogTitle>
          <Typography variant="h6">{popupMessage?.id}</Typography>
          <IconButton
            aria-label="close"
            onClick={handleClose}
            style={{ position: "absolute", right: 8, top: 8 }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent>
          <Typography variant="body2" sx={{ whiteSpace: "pre-line" }}>
            {popupMessage?.message}
          </Typography>
        </DialogContent>
      </Dialog>
    </div>
  );
};

export default Prompts;
